module.exports = require('./lib/static/prefixAll')



//////////////////
// WEBPACK FOOTER
// /opt/atlassian/pipelines/agent/build/~/inline-style-prefixer/static.js
// module id = 635
// module chunks = 0